import ViewBase from "../../../../framework/core/mvvm/view_base";
import GameUtil from "../../../../utility/game_util";
import Utility from "../../../../utility/utility";
import EventManager from "../../../../manager/event_manager";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import { promises } from "dns";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ShopItemCompent extends cc.Component {
    @property(cc.Sprite)
    itemIcon:cc.Sprite = null

    @property(cc.Label)
    zheKou:cc.Label = null

    @property(cc.Label)
    bili:cc.Label = null

    @property(cc.Label)
    minCount:cc.Label = null

    @property(cc.Label)
    countLab:cc.Label = null

    @property(cc.Label)
    priceLab:cc.Label = null

    @property(cc.Node)
    lineNode:cc.Node = null

    @property(cc.Node)
    huobiNode = null

    @property(cc.Node)
    daojuNode:cc.Node = null

    @property(cc.Label)
    nameLab:cc.Label = null

    @property(cc.Label)
    desLab:cc.Label = null

    @property(cc.Node)
    buyBtn:cc.Node = null

    @property(cc.SpriteFrame)
    iconAtlas:cc.SpriteFrame[] = []

    @property(cc.SpriteFrame)
    iconDaiBiAtlas:cc.SpriteFrame[] = []

    @property(SpriteFrameHolder)
    iconSprAtlas:SpriteFrameHolder = null

    @property(cc.Node)
    priceTHB:cc.Node = null

    @property(cc.Node)
    priceDaiBi:cc.Node = null

    @property(cc.Node)
    oldPriceNode:cc.Node = null

    @property(cc.Label)
    oldPriceLab:cc.Label = null


    itemData = null
    priceData = null
    
    onLoad(){
        this.buyBtn.on('click', this.onBuyEvent, this)
    }


    setData(viewBase :ViewBase, data: any, index, payId){
        let self = this
        this.itemData = data
        if (this.itemData == null){
            this.node.active = false
            return false
        }

        let priceStr = 0
        if (data.goodsType == "currency"){
                
            this.priceData = null        
            for (let index = 0; index < this.itemData.payLanePrices.length; index++) {
                const element = this.itemData.payLanePrices[index];
                if (element.payLaneId == payId){
                    this.priceData = element
                    break
                }
                
            }

            if (this.priceData == null){
                this.node.active = false
                return false
            }
            let addCount = 0
            this.zheKou.string = ""
            if (this.itemData.giftList.length > 0){
                for (let index = 0; index < this.itemData.giftList.length; index++) {
                    addCount += this.itemData.giftList[index].num
                }
                this.zheKou.string = "+" + Math.floor((addCount * 100) /this.itemData.num) + "%"
            }
            let strBili = Utility.currencyFormatting(Math.ceil((this.itemData.num + addCount)/this.priceData.price), true)
            if (this.itemData.goodsAccountType == 100){
                strBili = Utility.currencyFormatting((this.itemData.num + addCount)/this.priceData.price, false)
            }
            this.bili.string = "(1THB = "  + strBili + ")"
            this.minCount.string = Utility.currencyFormatting(this.itemData.num, true) 
            this.countLab.string = Utility.currencyFormatting(this.itemData.num + addCount, true)
            this.itemIcon.spriteFrame =  this.itemData.goodsAccountType == 100 ? this.iconDaiBiAtlas[index] : this.iconAtlas[index]
           // this.lineNode.width = this.minCount.node.getContentSize().width + 10
            this.daojuNode.active = false
            this.huobiNode.active = true
            priceStr = this.priceData.price
        }
        else{
            this.nameLab.string = this.itemData.goodsDescription
            this.desLab.string = this.itemData.goodsName 
            this.daojuNode.active = true
            this.huobiNode.active = false
            if (this.itemData.goodsType = "item"){
                let sprName = this.itemData.goodsCode.split("_")[0]
                this.itemIcon.spriteFrame = this.iconSprAtlas.getSpriteFrameByKey(sprName)
            }
            else{
                this.itemIcon.spriteFrame = this.iconSprAtlas.getSpriteFrameByKey(this.itemData.goodsType)
            }
            priceStr = this.itemData.discountPrice
        }
        this.priceTHB.active = this.itemData.costType == 1
        this.priceDaiBi.active = this.itemData.costType == 100
        this.oldPriceLab.string =  GameUtil.currencyFormatting(this.itemData.defaultPrice)
        this.oldPriceNode.active = !(this.itemData.defaultPrice == priceStr)
        this.priceLab.string = GameUtil.currencyFormatting(priceStr)//+ this.itemData.defaultCurrency
        this.node.active = true
        return true
    }

    onBuyEvent(){
        Utility.playButtonSound();
        if (this.itemData == null){ return } 
        EventManager.instance.dispatch('click_buy_item', {Data:this.itemData, PriceData:this.priceData})
    }
}
